import ConditionalButton from "./ConditionalButton";
import { IconCheck, IconX } from "@tabler/icons-react";
import PopUp, { closeModal, openModal } from "./PopUp";
import { ReactNode, useState } from "react";
import { LOADING_CIRCLE } from "./loading/LoadingCircle.tsx";

export type PopUpDialogProps = {
  id: string;
  onClick?: () => void | Promise<void>;
  onCancel?: () => void | Promise<void>;
  onDismiss?: () => void | Promise<void>;
  children?: ReactNode;
  loading?: boolean;
  className?: string;
  title: ReactNode;
  description?: ReactNode;
  type?: "button" | "submit" | "reset";
};
const PopUpDialog = ({
  id,
  onClick,
  onCancel,
  onDismiss,
  loading = false,
  children,
  className,
  title,
  description,
  type,
}: PopUpDialogProps) => {
  const [loadingState, setLoading] = useState(loading);
  const close = async () => {
    if (onCancel) await onCancel();
    closeModal(id);
  };
  const open = () => openModal(id);
  const handleSubmit = async () => {
    if (!loadingState) setLoading(true);
    if (onClick) await onClick();
    setTimeout(() => {
      close();
      setLoading(false);
    }, 500);
  };
  return (
    <>
      <button className={className} onClick={open} type="button">
        {children}
      </button>
      <PopUp id={id} title={title} onDismiss={onDismiss}>
        <div className="flex flex-col gap-3.25 p-2">
          {description}
          <div className="flex w-full justify-stretch items-center gap-4">
            <button
              className="btn btn-error grow"
              disabled={loadingState}
              type="button"
              onClick={close}
            >
              <IconX />
            </button>
            <ConditionalButton
              className="btn btn-success grow"
              classNameLoading="btn btn-ghost skeleton grow"
              isLoading={loadingState}
              whenLoading={LOADING_CIRCLE}
              type={type}
              onClick={handleSubmit}
            >
              <IconCheck />
            </ConditionalButton>
          </div>
        </div>
      </PopUp>
    </>
  );
};
export default PopUpDialog;
